import { useQuery } from 'hooks/useQuery'

import { fetchUsersByUsernames } from 'utils/queries'

import { UserType } from 'types/user'

import { useDiscoverContent } from './useDiscoverContent'

/**
 * Retrieves the User for each Emerging Coach as specified in the DiscoverContent entry in the DB.
 * @returns a query for an array of users.
 */
export const useEmergingCoaches = () => {
  const { data: discoverContent } = useDiscoverContent()

  if (!discoverContent) {
    console.error('No DiscoverContent in the database.')
  }

  const emergingCoachUsernames = discoverContent ? discoverContent.sections[0].tags : []

  const coachPromises = fetchUsersByUsernames(emergingCoachUsernames)

  return useQuery<Array<UserType | null>>(['users', ...emergingCoachUsernames], () => coachPromises)
}
